import { makeStyles } from "@material-ui/core/styles";

import CloseIcon from "@mui/icons-material/Close";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SendIcon from "@mui/icons-material/Send";
import DeleteIcon from "@mui/icons-material/Delete";

import { IsMobile } from "utils/is-mobile";

const useStyles = makeStyles(() => ({
  cartClosed: {
    transform: "translateX(100%)",
  },
  cartOpen: {
    transform: "translateX(0)",
  },
}));

export default function CartSidebar({
  isCartOpen,
  setIsCartOpen,
  cartDetails,
  brandColors,
  selectedBrand,
  subtotal,
  total,
  discount,
  onRemoveFromCart,
  onUpdateCartQuantity,
  onFinishOrder,
  canFinishOrder = true,
}) {
  const classes = useStyles();
  const mobile = IsMobile();
  const isKarstenLayout = selectedBrand === "karsten";
  const isMixLayout = selectedBrand === "mix";

  return (
    <>
      {isCartOpen && (
        <div
          onClick={() => setIsCartOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1199,
            transition: "opacity 0.3s ease-in-out",
          }}
        />
      )}

      <aside
        className={`cart-section ${
          isCartOpen ? classes.cartOpen : classes.cartClosed
        }`}
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          height: "100%",
          width: mobile ? "100%" : "384px",
          maxWidth: mobile ? "100%" : "384px",
          backgroundColor: brandColors.surface,
          boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1)",
          transform: isCartOpen ? "translateX(0)" : "translateX(100%)",
          transition: "transform 0.3s ease-in-out",
          display: "flex",
          flexDirection: "column",
          zIndex: 1200,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px",
            borderBottom: `1px solid ${brandColors.border}`,
          }}
        >
          <h2
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              color: brandColors.textBase,
              fontFamily: "inherit",
            }}
          >
            Meu Pedido
          </h2>
          <button
            onClick={() => setIsCartOpen(false)}
            style={{
              padding: "4px",
              borderRadius: "9999px",
              border: "none",
              background: "transparent",
              cursor: "pointer",
            }}
          >
            <CloseIcon
              style={{ fontSize: "24px", color: brandColors.textBase }}
            />
          </button>
        </div>
        <div
          style={{
            flexGrow: 1,
            padding: "16px",
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {cartDetails.length === 0 ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                textAlign: "center",
                color: brandColors.textMuted,
              }}
            >
              <ShoppingCartIcon
                style={{ fontSize: "64px", marginBottom: "16px" }}
              />
              <p style={{ fontWeight: 600 }}>Seu carrinho está vazio.</p>
            </div>
          ) : (
            <div>
              {cartDetails.map((item) => {
                const itemPrice = parseFloat(item.preco.replace(",", "."));
                const itemLastPrice = parseFloat(
                  item.precoAnterior?.replace(",", ".") || 0
                );
                const itemTotalDiscount = itemLastPrice
                  ? itemLastPrice * item.quantidade
                  : 0;
                const itemTotal = itemPrice * item.quantidade;
                const priceColor = isMixLayout
                  ? item.marcaId === 1 || item.marcaId === 3
                    ? brandColors.karstenAccent
                    : brandColors.trussardiAccent
                  : brandColors.primary;

                return (
                  <div
                    key={item.idProduto}
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "12px 0",
                      borderBottom: `1px solid ${brandColors.border}`,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        minWidth: 0,
                        marginBottom: mobile ? "8px" : 0,
                        width: "100%",
                      }}
                    >
                      <img
                        src={item.fotos?.[0] || ""}
                        alt={item.name}
                        style={{
                          width: "64px",
                          height: "64px",
                          objectFit: "cover",
                          borderRadius: "8px",
                          marginRight: "16px",
                          flexShrink: 0,
                        }}
                        onError={(e) => {
                          e.target.src =
                            "https://placehold.co/100x100/ccc/fff?text=Img";
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                          minWidth: 0,
                          flexGrow: 1,
                        }}
                      >
                        <span
                          style={{
                            fontWeight: 600,
                            fontSize: "14px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            fontFamily: "inherit",
                          }}
                        >
                          {item.name}
                        </span>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            {itemLastPrice > 0 ? (
                              <span
                                style={{
                                  fontWeight: 300,
                                  fontSize: "12px",
                                  color: brandColors.textMuted,
                                  textDecoration: "line-through",
                                }}
                              >
                                R${" "}
                                {itemTotalDiscount.toFixed(2).replace(".", ",")}
                              </span>
                            ) : (
                              <span style={{ height: "12px" }} />
                            )}
                            <span
                              style={{
                                fontWeight: 600,
                                fontSize: "16px",
                                color: priceColor,
                              }}
                            >
                              R$ {itemTotal.toFixed(2).replace(".", ",")}
                            </span>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              justifyContent: "flex-end",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                border: `1px solid ${brandColors.border}`,
                                borderRadius: "6px",
                                width: "64px",
                                justifyContent: "space-between",
                              }}
                            >
                              <button
                                onClick={() => {
                                  if (item.quantidade <= 1) {
                                    onRemoveFromCart(item.idProduto);
                                  } else {
                                    onUpdateCartQuantity(
                                      item.idProduto,
                                      item.quantidade - 1
                                    );
                                  }
                                }}
                                style={{
                                  padding: "4px",
                                  border: "none",
                                  background: "transparent",
                                  cursor: "pointer",
                                  color: brandColors.textBase,
                                }}
                              >
                                -
                              </button>
                              <span
                                style={{ padding: "0 8px", fontSize: "14px" }}
                              >
                                {item.quantidade}
                              </span>
                              <button
                                onClick={() =>
                                  onUpdateCartQuantity(
                                    item.idProduto,
                                    item.quantidade + 1
                                  )
                                }
                                style={{
                                  padding: "4px",
                                  border: "none",
                                  background: "transparent",
                                  cursor: "pointer",
                                  color: brandColors.textBase,
                                }}
                              >
                                +
                              </button>
                            </div>
                            <button
                              onClick={() => onRemoveFromCart(item.idProduto)}
                              style={{
                                padding: "4px",
                                flexShrink: 0,
                                color: brandColors.textMuted,
                                border: "none",
                                background: "transparent",
                                cursor: "pointer",
                              }}
                              onMouseEnter={(e) =>
                                (e.target.style.color = "#d32f2f")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.color = brandColors.textMuted)
                              }
                            >
                              <DeleteIcon style={{ fontSize: "16px" }} />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        {cartDetails.length > 0 && (
          <div
            style={{
              padding: "16px",
              borderTop: `1px solid ${brandColors.border}`,
              backgroundColor: isKarstenLayout ? "#f9fafb" : "transparent",
            }}
          >
            <div style={{ marginBottom: "16px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: "14px",
                  color: brandColors.textMuted,
                  marginBottom: "8px",
                }}
              >
                <span>Subtotal</span>
                <span>R$ {subtotal.toFixed(2).replace(".", ",")}</span>
              </div>
              {discount > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "14px",
                    color: isKarstenLayout ? "#10b981" : brandColors.primary,
                    marginBottom: "8px",
                  }}
                >
                  <span>Descontos</span>
                  <span>- R$ {discount.toFixed(2).replace(".", ",")}</span>
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
              >
                <span style={{ color: brandColors.primary }}>Total</span>
                <span
                  style={{
                    fontSize: "24px",
                    color: brandColors.primary,
                  }}
                >
                  R$ {total.toFixed(2).replace(".", ",")}
                </span>
              </div>
            </div>
            <button
              onClick={onFinishOrder}
              disabled={!canFinishOrder}
              style={{
                width: "100%",
                backgroundColor: canFinishOrder
                  ? brandColors.primary
                  : brandColors.border,
                color: canFinishOrder ? "white" : brandColors.textMuted,
                fontWeight: "bold",
                padding: "12px",
                borderRadius: "8px",
                border: "none",
                cursor: canFinishOrder ? "pointer" : "not-allowed",
                transition: "background-color 0.3s",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onMouseEnter={(e) => {
                if (canFinishOrder) {
                  e.target.style.backgroundColor = brandColors.primaryHover;
                }
              }}
              onMouseLeave={(e) => {
                if (canFinishOrder) {
                  e.target.style.backgroundColor = brandColors.primary;
                }
              }}
            >
              <SendIcon style={{ fontSize: "20px", marginRight: "8px" }} />
              Enviar Pedido
            </button>
          </div>
        )}
      </aside>
    </>
  );
}
